const updateWorkoutsErrors = (state, { payload: { errors } }) => {
	state.errors = errors;
};

export default updateWorkoutsErrors;
